<script>
  export default {
    props: {
      title: {
        type: String,
        default: ''
      },
      subTitle: {
        type: String,
        default: ''
      },
    },
    data() {
      return {}
    }
  }
</script>

<template>
  <div class="baseSectionTitle">
    <span class="baseSectionTitle__subTitle font-cursive ls-0 color-primary">{{ subTitle }}</span>
    <h2 class="baseSectionTitle__title" v-html="title"></h2>
  </div>
</template>
<style lang="scss">
  .baseSectionTitle {
    max-width: 500px;
    margin-bottom: 90px;
    @include max-lg {
      // margin-top: 116px;
      margin-bottom: 54px;
    }

    &__subTitle {
      font-size: 28px;
      @include max-md {
        font-size: 21px;
      }
    }

    &__title {
      font-size: 40px;
      font-weight: 600;
      line-height: 1.5;
      letter-spacing: 0.1em;
      @include max-md {
        font-size: 30px;
      }

      .color-primary {
        color: $color-primary;
      }
    }

    &.isStyleDecoration {
      position: relative;

      &:before {
        position: absolute;
        content: url('~@assets/images/home/line.svg');
        bottom: -24px;
        left: 0;
      }

      &.isCenter {
        &:before {
          right: 0;
          left: 0;
        }
      }

      &.islgCenter {
        &:before {
          @include max-lg {
            right: 0;
            left: 0;
          }
        }
      }

      &.isxlCenter {
        &:before {
          @include max-xl {
            right: 0;
            left: 0;
          }
        }
      }
    }
  }
</style>
